<template>
	<div
		class="medias-selector clearfix"
		:class="{
			freeMedias: classified.mode == 'print_web',
			recruiter: classified.profil == 'recruiter',
		}"
	>
		<fieldset>
			<legend>Photos</legend>
		</fieldset>
		<p>
			<em
				>Formats acceptés : .jpg ou .png - Poids maximum: 5 Mo - Taille maximum
				: 5000px x 5000px</em
			>
			<!-- <strong v-id="is_admin">{{maxMedias}} photos maximum</strong> -->
		</p>
		<draggable
			v-model="classified.medias"
			group="people"
			handle="img"
			@start="drag = true"
			@end="drag = false"
		>
			<Media
				:id="media_id"
				v-for="media_id in classified.medias"
				:key="media_id"
			/>
		</draggable>
		<FilePond
			name="filepond-media"
			ref="pond_media"
			allowMultiple="true"
			:maxFiles="maxMedias"
			v-show="classified.medias.length < maxMedias"
			acceptedFileTypes="image/jpeg, image/png"
			maxFileSize="5MB"
			imageValidateSizeMaxWidth="5000"
			imageValidateSizeMaxHeight="5000"
			labelIdle="<span class='filepond--label-action'></span>"
			labelMaxFileSizeExceeded="Le fichier est trop lourd"
			labelFileProcessing="Upload en cours"
			labelFileProcessingComplete="Upload terminé"
			@addfile="handleFileAddedMedia"
			@processfile="handleProcessFileMedia"
			@init="handleFilePondInitMedia"
		/>
		<div
			class="pa-block__sidebar pa-block__sidebar--photos"
			v-if="classified.mode == 'web' && classified.medias.length > 0"
		>
			<fieldset>
				<legend>Prix total des photos :</legend>
			</fieldset>
			<table>
				<tr>
					<td>
						<strong>
							{{ classified.medias.length }} photo{{
								classified.medias.length > 1 ? "s" : ""
							}}
							({{ parseInt(classified.duration) }}
							{{
								classified.mode == "web"
									? "mois"
									: "semaine" + (parseInt(classified.duration) > 1 ? "s" : "")
							}})
						</strong>
					</td>
					<td>
						{{
							numberFormat(
								classified.medias.length *
									settings.options[classified.profil].option_media *
									parseInt(classified.duration)
							)
						}}
						€ <small>TTC</small>
					</td>
				</tr>
				<tr
					v-if="
						durationDiscount(parseInt(classified.duration), classified, true)
					"
				>
					<td>
						<strong>
							Remise (-{{
								durationDiscount(
									parseInt(classified.duration),
									classified,
									true
								)
							}}%)
						</strong>
					</td>
					<td>
						{{
							numberFormat(
								classified.medias.length *
									settings.options[classified.profil].option_media *
									parseInt(classified.duration) *
									(1 -
										durationDiscount(parseInt(classified.duration), classified))
							)
						}}
						€ <small>TTC</small>
					</td>
				</tr>
				<tr
					v-if="
						durationDiscount(parseInt(classified.duration), classified, true)
					"
				>
					<td>
						<strong>
							Pour {{ parseInt(classified.duration) }}
							{{
								classified.mode == "web"
									? "mois"
									: "semaine" + (parseInt(classified.duration) > 1 ? "s" : "")
							}}
						</strong>
					</td>
					<td>
						{{
							numberFormat(
								classified.medias.length *
									settings.options[classified.profil].option_media *
									parseInt(classified.duration) *
									durationDiscount(parseInt(classified.duration), classified)
							)
						}}
						€ <small>TTC</small>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import vueFilePond, { setOptions } from "vue-filepond";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import draggable from "vuedraggable";
import Media from "./Media.vue";

// import "filepond/dist/filepond.min.css";

export default {
	name: "medias-selector",
	components: {
		FilePond: vueFilePond(
			FilePondPluginImageValidateSize,
			FilePondPluginFileValidateSize,
			FilePondPluginFileValidateType
		),
		Media,
		draggable,
	},
	mounted() {},
	created() {
		const self = this;
	},
	computed: {
		...mapState([
			"maxMedias",
			"classified",
			"allMedias",
			"settings",
			"is_admin",
		]),
	},
	methods: {
		filePrice() {
			return this.classified.mode == "web";
			// return this.classified.medias.length < this.maxMedias ? "free" : "paying";
		},
		handleProcessFileMedia: function (e, file) {
			setTimeout(() => {
				this.$refs.pond_media.removeFile(file.id);
			}, 500);
			this.$store.commit("addMedia", parseInt(file.serverId));
		},
		handleFileAddedMedia: function (e) {
			this.$refs.pond_media.getFiles().forEach((file) => {
				/*
        INIT: 1,
        IDLE: 2,
        PROCESSING_QUEUED: 9,
        PROCESSING: 3,
        PROCESSING_COMPLETE: 5,
        PROCESSING_ERROR: 6,
        PROCESSING_REVERT_ERROR: 10,
        LOADING: 7,
        LOAD_ERROR: 8
        */
				switch (file.status) {
					case 2:
						this.$refs.pond_media.processFile(file.id).then((file) => {
							// this.$refs.pond_media.removeFile(file.id);
						});
						break;
				}
			});
		},
		handleFilePondInitMedia: function () {
			this.$refs.pond_media.server = {
				process: (
					fieldName,
					file,
					metadata,
					load,
					error,
					progress,
					abort,
					transfer,
					options
				) => {
					const formData = new FormData();
					formData.append("uniq_id", this.classified.uniq_id);
					formData.append(fieldName, file, file.name);
					let config = {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					};

					this.$store.commit("startXhr");
					axios
						.post(
							this.config.app.gateway +
								"?action=classified_v2_save_classified_medias",
							formData,
							config
						)
						.then((response) => {
							this.$store.commit("addAllMedias", response.data);
							load(response.data.attachment_id);
						})
						.catch((response) => {
							error(response);
						})
						.finally(() => this.$store.commit("endXhr"));

					return {
						abort: function () {
							abort();
						},
					};
				},
			};
		},
	},
};
</script>
<style lang="scss">
.media {
	display: inline-block;
	margin: 3px;
}
.filepond--list-scroller {
	transform: translate3d(0px, 128px, 0px);
}
.filepond--item {
	width: 100%;
}
.filepond--wrapper {
	display: inline-block;
	margin: 1.65rem 0.5rem 3px 0.5rem;
}
.filepond--drop-label {
	position: relative;
	label {
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		position: absolute;
	}
}

.filepond--label-action {
	margin: -10px 0 0 -10px;
	background: url(../assets/upload.png) 50% 50% no-repeat;
	display: block;
	width: 10rem;
	height: 100rem;
	position: relative;

	&:after {
		content: "En option : 9€ TTC";
		top: 150px;
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		color: #d22e26;
	}

	@media (max-width: 991.98px) {
		background-size: 55% 55%;
		background-position: 50% 25%;
		height: 6.25rem;
		width: 6.25rem;
	}
}
.medias-selector.recruiter .filepond--label-action {
	&:after {
		content: "En option : 24€ TTC";
	}
}

.medias-selector.freeMedias .filepond--label-action {
	&:after {
		content: "inclus";
	}
}
.filepond--file .filepond--file-status {
	align-items: flex-start;
	transform: none;
	width: 100%;
	padding-right: 2em;
	margin: 0;
	text-align: left;
	align-items: flex-start;
	* {
		white-space: normal;
	}
}
.filepond--file .filepond--file-info {
	display: none;
}
.filepond--file-status .filepond--file-status-sub {
	opacity: 0 !important;
}
.filepond--credits {
	display: none !important;
}
</style>
